import { BuildClass, Do, clamp } from '../../universal';
import { React, _ } from '../lib';
import { J2rModalPortal, j2r } from './component-react';
import { moment } from './moment-wrapper';
import { Bindings, ConditionalObject, stubDOMRect } from './ui5';
export class J2rDatetime extends React.Component {
    static defaultProps = {
        minYear: 1900,
        maxYear: 2100,
    };
    element;
    constructor(props) {
        super(props);
        Bindings(this, [
            this.onClick,
            this.onKeyDown,
            this.onTextChanged,
            this.onTxtBlur,
            this.onTxtFocus,
            this.stopProp,
        ]);
        this.element = React.createRef();
        if (!(this.props.includeDate ?? true) && !this.props.includeTime) {
            console.error('J2rDatetime set to include neither date nor time');
        }
        const value = this.parseValue(this.props.value);
        this.state = {
            value,
            valueRaw: this.getValueRaw(value),
            isEditing: false,
            isOpen: false,
            isFocused: false,
            zoomLevel: this.getDefaultZoom(),
            selectionPath: this.getSelectionPath(value),
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            const value = this.parseValue(this.props.value);
            this.setState({
                value,
                isEditing: false,
                valueRaw: this.getValueRaw(value),
                selectionPath: this.getSelectionPath(value),
            });
        }
    }
    stopProp(e) {
        e.stopPropagation();
        e.preventDefault();
    }
    render() {
        return j2r({
            cl: BuildClass({
                [this.props.cl ?? '']: true,
                tb2: true,
                'j2r-dt': true,
                unsaved: this.state.isEditing,
                focused: this.state.isFocused,
                disabled: this.props.disabled ?? false,
            }),
            children: [
                {
                    tag: 'input',
                    key: 'text-input',
                    ref: this.element,
                    cl: 'txt txtDate date',
                    value: this.state.valueRaw,
                    disabled: this.props.disabled,
                    tabIndex: this.props.tabIndex,
                    autoFocus: this.props.autoFocus,
                    readOnly: this.props.disableTextEntry,
                    placeholder: Do(() => {
                        if (this.props.placeholder != null) {
                            return this.props.placeholder;
                        }
                        else if (!this.props.includeTime) {
                            return 'dd/mm/yyyy';
                        }
                        else if (!(this.props.includeDate ?? true)) {
                            return 'hh:mm';
                        }
                        return 'dd/mm/yyyy, hh:mm';
                    }),
                    onChange: this.onTextChanged,
                    onFocus: this.onTxtFocus,
                    onBlur: this.onTxtBlur,
                    onKeyDown: this.onKeyDown,
                    onClick: this.onClick,
                },
                {
                    tag: J2rModalPortal,
                    key: 'widget-modal',
                    children: [this.buildModal()],
                },
            ],
        });
    }
    buildModal() {
        return {
            key: 'datetime-widget',
            cl: BuildClass({
                'j2r-dt-widget': true,
                open: this.state.isOpen,
            }),
            children: ConditionalObject(this.state.isOpen, [
                this.buildWidgetToolbar(),
                this.buildWidgetGrid(),
            ]),
            style: Do(() => {
                const el = this.element.current;
                const box = el?.getBoundingClientRect() ?? stubDOMRect;
                return {
                    top: `${box.bottom - 1}px`,
                    left: `${box.left}px`,
                };
            }),
            onMouseDown: this.stopProp,
            onWheel: (e) => {
                if (e.deltaY < 0) {
                    this.moveNav(-1);
                }
                else if (e.deltaY > 0) {
                    this.moveNav(+1);
                }
            },
        };
    }
    buildWidgetToolbar() {
        return {
            cl: 'toolbar noselect',
            key: 'toolbar',
            children: [
                {
                    key: 'lhs',
                    cl: BuildClass({
                        lhs: true,
                        side: true,
                        invisible: this.state.zoomLevel === 1,
                    }),
                    text: '↑',
                    onMouseDown: this.stopProp,
                    onClick: () => {
                        this.moveNav(-1);
                    },
                },
                {
                    key: 'home',
                    cl: 'home icon',
                    title: 'Jump to today',
                    children: [
                        {
                            tag: 'img',
                            key: 'img',
                            src: '/static/img/svg/home.svg',
                        },
                    ],
                    onMouseDown: this.stopProp,
                    onClick: () => {
                        this.setState({
                            selectionPath: this.getSelectionPath(moment()),
                            zoomLevel: (this.props.includeDate ?? true) ? 4 : 5,
                        });
                    },
                },
                {
                    key: 'title',
                    cl: BuildClass({
                        title: true,
                        'non-clickable': this.state.zoomLevel === 1,
                    }),
                    onMouseDown: this.stopProp,
                    onClick: () => {
                        this.moveNesting(-1);
                    },
                    text: Do(() => {
                        const P = this.state.selectionPath;
                        const dt = moment({
                            year: P[0] * 10 + P[1],
                            month: P[2] ? P[2] - 1 : 1,
                            day: P[3] ?? 1,
                            hour: P[4] ?? 1,
                        });
                        switch (this.state.zoomLevel) {
                            case 1:
                                return '';
                            case 2:
                                return `${P[0]}0s`;
                            case 3:
                                return dt.format('YYYY');
                            case 4:
                                return dt.format('MMMM, YYYY');
                            case 5:
                                return dt.format('DD/MM/YYYY');
                            case 6:
                                const h = dt.format('HH');
                                const d = dt.format('DD/MM/YY');
                                return `${h}:xx, ${d}`;
                        }
                        return '';
                    }),
                },
                {
                    key: 'target',
                    cl: BuildClass({
                        icon: true,
                        target: true,
                        nohover: this.state.value == null,
                    }),
                    title: 'Jump to current value',
                    children: [
                        {
                            tag: 'img',
                            key: 'img',
                            src: '/static/img/svg/target.svg',
                        },
                    ],
                    onMouseDown: this.stopProp,
                    onClick: () => {
                        if (this.state.value != null) {
                            this.setState({
                                selectionPath: this.getSelectionPath(this.state.value),
                            });
                        }
                    },
                },
                {
                    key: 'rhs',
                    cl: BuildClass({
                        rhs: true,
                        side: true,
                        invisible: this.state.zoomLevel === 1,
                    }),
                    text: '↓',
                    onMouseDown: this.stopProp,
                    onClick: () => {
                        this.moveNav(+1);
                    },
                },
            ],
        };
    }
    buildWidgetGrid() {
        return _.assign({ key: 'grid' }, Do(() => {
            switch (this.state.zoomLevel) {
                case 1:
                    return this.buildWidgetGridDecades();
                case 2:
                    return this.buildWidgetGridYears();
                case 3:
                    return this.buildWidgetGridMonths();
                case 4:
                    return this.buildWidgetGridDays();
                case 5:
                    return this.buildWidgetGridHours();
                case 6:
                    return this.buildWidgetGridMinutes();
            }
            return null;
        }));
    }
    buildGridOfOptions(param) {
        const today = param.getID(moment());
        const current = param.getID(this.state.value);
        const groupID = param.getGroupID?.(param.startDateGroup ?? param.startDate);
        return {
            cl: 'calendar-view',
            children: _.flatten([
                ConditionalObject(param.headingRow != null, () => _.assign({}, param.headingRow, { key: 'heading' })),
                _.times(param.rowCount, y => ({
                    key: y,
                    cl: BuildClass({
                        ...(param.cl ? { [param.cl]: true } : {}),
                        'calendar-row': true,
                        gridRow: true,
                    }),
                    children: _.times(param.colCount, x => {
                        const dDate = param.getCellDate(param.startDate.clone(), x, y);
                        const dID = param.getID(dDate);
                        return {
                            tag: 'span',
                            key: x,
                            cl: BuildClass({
                                day: true,
                                oog: Boolean(groupID &&
                                    param.getGroupID &&
                                    groupID !== param.getGroupID(dDate)),
                                today: dID === today,
                                current: dID === current,
                            }),
                            text: param.getCellText(dDate),
                            title: (param.getCellTitle ?? param.getCellText)(dDate),
                            onMouseDown: this.stopProp,
                            onClick: (e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                (param.onClick ?? _.noop)(dDate);
                            },
                        };
                    }),
                })),
            ]),
        };
    }
    buildWidgetGridDecades() {
        return this.buildGridOfOptions({
            startDate: moment({
                year: 1900,
                month: 0,
                date: 1,
            }),
            rowCount: 5,
            colCount: 4,
            getID: x => String(Math.floor((x?.year() ?? -1) / 10)),
            getCellDate: (start, x, y) => start.add((y * 4 + x) * 10, 'year'),
            getCellText: x => {
                const decade = Math.floor(x.year() / 10);
                return `${decade}0s`;
            },
            getGroupID: undefined,
            onClick: d => {
                this.setState(s => ({
                    zoomLevel: s.zoomLevel + 1,
                    selectionPath: Do(() => {
                        const p = _.clone(s.selectionPath);
                        p[0] = Math.floor(d.year() / 10);
                        return p;
                    }),
                }));
                this.moveNav(0);
            },
        });
    }
    buildWidgetGridYears() {
        return this.buildGridOfOptions({
            startDate: moment({
                year: this.state.selectionPath[0] * 10,
                month: 0,
                date: 1,
            }),
            rowCount: 5,
            colCount: 4,
            getID: x => String(x?.year() ?? -1),
            getCellDate: (start, x, y) => start.add((y - 1) * 4 + x, 'year'),
            getCellText: x => x.format('YYYY'),
            getGroupID: x => String(Math.floor(x.year() / 10)),
            onClick: d => {
                this.setState(s => ({
                    zoomLevel: s.zoomLevel + 1,
                    selectionPath: Do(() => {
                        const p = _.clone(s.selectionPath);
                        p[0] = Math.floor(d.year() / 10);
                        p[1] = d.year() % 10;
                        return p;
                    }),
                }));
                this.moveNav(0);
            },
        });
    }
    buildWidgetGridMonths() {
        return this.buildGridOfOptions({
            startDate: moment({
                year: this.state.selectionPath[0] * 10 + this.state.selectionPath[1],
                month: 0,
                date: 1,
            }),
            rowCount: 5,
            colCount: 4,
            getID: x => x?.format('MM/YYYY') ?? '',
            getCellDate: (start, x, y) => start.add((y - 1) * 4 + x, 'month'),
            getCellText: x => x.format('MMM'),
            getCellTitle: x => x.format('MMMM, YYYY'),
            getGroupID: x => String(x.year()),
            onClick: d => {
                this.setState(s => ({
                    zoomLevel: s.zoomLevel + 1,
                    selectionPath: Do(() => {
                        const p = _.clone(s.selectionPath);
                        p[0] = Math.floor(d.year() / 10);
                        p[1] = d.year() % 10;
                        p[2] = d.month() + 1;
                        return p;
                    }),
                }));
                this.moveNav(0);
            },
        });
    }
    buildWidgetGridDays() {
        return this.buildGridOfOptions({
            cl: 'days',
            headingRow: {
                cl: 'heading-row calendar-row gridRow days',
                children: ['M', 'T', 'W', 'T', 'F', 'S', 'S'].map((txt, idx) => ({
                    tag: 'span',
                    key: idx,
                    text: txt,
                })),
            },
            startDate: Do(() => {
                const date_ = moment({
                    year: this.state.selectionPath[0] * 10 + this.state.selectionPath[1],
                    month: this.state.selectionPath[2] - 1,
                    date: 1,
                });
                if (!date_.isValid()) {
                    console.error('Invalid date', date_);
                    return moment();
                }
                while (date_.isValid() && date_.day() !== 1) {
                    date_.add(-1, 'd');
                }
                return date_;
            }),
            startDateGroup: moment({
                year: this.state.selectionPath[0] * 10 + this.state.selectionPath[1],
                month: this.state.selectionPath[2] - 1,
                date: 1,
            }),
            rowCount: 6,
            colCount: 7,
            getID: x => x?.format('DD/MM/YYYY') ?? '',
            getCellDate: (start, x, y) => start.add(y * 7 + x, 'd'),
            getCellText: x => String(x.date()),
            getCellTitle: x => x.format('dddd, DD/MM/YYYY'),
            getGroupID: x => x.format('MM/YYYY'),
            onClick: d => {
                if (!this.props.includeTime) {
                    this.updateValue(d);
                    this.setState({ isOpen: false });
                    return;
                }
                this.setState(s => ({
                    zoomLevel: s.zoomLevel + 1,
                    selectionPath: Do(() => {
                        const p = _.clone(s.selectionPath);
                        p[0] = Math.floor(d.year() / 10);
                        p[1] = d.year() % 10;
                        p[2] = d.month() + 1;
                        p[3] = d.date();
                        return p;
                    }),
                }));
                this.moveNav(0);
            },
        });
    }
    buildCircleOfOptions(param) {
        const today = param.getID(moment());
        const current = param.getID(this.state.value);
        return {
            key: param.key,
            cl: BuildClass({
                [param.cl]: true,
                circle: true,
            }),
            children: _.map(param.segments, (segment, index) => {
                const dDate = param.getSegmentDT(param.startDate.clone(), segment.value);
                const dID = param.getID(dDate);
                return {
                    key: index,
                    cl: BuildClass({
                        segment: true,
                        today: dID === today,
                        current: dID === current,
                    }),
                    children: [
                        {
                            tag: 'span',
                            cl: 'txt',
                            key: 'txt',
                            text: segment.text,
                            style: {
                                transform: Do(() => {
                                    const degs = (index * 360) / param.segments.length;
                                    return `rotate(-${degs}deg)`;
                                }),
                            },
                        },
                    ],
                    style: _.assign({}, segment.style, {
                        transform: Do(() => {
                            const degs = (index * 360) / param.segments.length;
                            const existing = segment.style?.transform ?? '';
                            return `${existing} rotate(${degs}deg)`;
                        }),
                    }),
                    onMouseDown: this.stopProp,
                    onClick: (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        segment.onClick(segment.value);
                    },
                };
            }),
        };
    }
    buildWidgetGridHours() {
        return {
            cl: 'hour-picker noselect',
            children: [
                this.buildCircleOfOptions({
                    cl: 'outer',
                    key: 'outer',
                    startDate: moment({
                        year: this.state.selectionPath[0] * 10 +
                            this.state.selectionPath[1],
                        month: this.state.selectionPath[2] - 1,
                        date: this.state.selectionPath[3],
                        hour: 0,
                        minute: 0,
                    }),
                    getID: x => x?.format('HH DD/MM/YYYY') ?? '',
                    getSegmentDT: (start, delta) => start.add(delta, 'hours'),
                    segments: _.times(12, x => ({
                        value: x,
                        text: x < 10 ? `0${x}` : String(x),
                        onClick: v => {
                            this.setState(s => ({
                                zoomLevel: s.zoomLevel + 1,
                                selectionPath: Do(() => {
                                    const p = _.clone(s.selectionPath);
                                    p[4] = v;
                                    return p;
                                }),
                            }));
                            this.moveNav(0);
                        },
                    })),
                }),
                this.buildCircleOfOptions({
                    cl: 'inner',
                    key: 'inner',
                    startDate: moment({
                        year: this.state.selectionPath[0] * 10 +
                            this.state.selectionPath[1],
                        month: this.state.selectionPath[2] - 1,
                        date: this.state.selectionPath[3],
                        hour: 0,
                        minute: 0,
                    }),
                    getID: x => x?.format('HH DD/MM/YYYY') ?? '',
                    getSegmentDT: (start, delta) => start.add(delta, 'hours'),
                    segments: _.times(12, x => ({
                        value: x + 12,
                        text: String(x + 12),
                        onClick: v => {
                            this.setState(s => ({
                                zoomLevel: s.zoomLevel + 1,
                                selectionPath: Do(() => {
                                    const p = _.clone(s.selectionPath);
                                    p[4] = v;
                                    return p;
                                }),
                            }));
                            this.moveNav(0);
                        },
                    })),
                }),
                {
                    cl: 'dot',
                    key: 'dot',
                },
            ],
        };
    }
    buildWidgetGridMinutes() {
        return {
            cl: 'hour-picker noselect',
            children: [
                this.buildCircleOfOptions({
                    cl: 'outer',
                    key: 'outer',
                    startDate: moment({
                        year: this.state.selectionPath[0] * 10 +
                            this.state.selectionPath[1],
                        month: this.state.selectionPath[2] - 1,
                        date: this.state.selectionPath[3],
                        hour: this.state.selectionPath[4],
                        minute: 0,
                    }),
                    getID: x => {
                        if (x == null) {
                            return '';
                        }
                        const dt = x.format('DD/MM/YYYY HH') ?? '';
                        const m = Math.floor(+x.format('mm') / 5);
                        return `${dt}${m}`;
                    },
                    getSegmentDT: (start, delta) => start.add(delta, 'minutes'),
                    segments: _.times(12, x => ({
                        value: x * 5,
                        text: Do(() => {
                            const v = String(x * 5);
                            if (v.length < 2) {
                                return `0${v}`;
                            }
                            return v;
                        }),
                        onClick: v => {
                            this.setState(s => ({
                                selectionPath: Do(() => {
                                    const p = _.clone(s.selectionPath);
                                    p[5] = v;
                                    return p;
                                }),
                            }));
                            this.moveNav(0, undefined, () => {
                                this.updateValue(this.getValueFromSelectionPath());
                                this.setState({ isOpen: false });
                            });
                        },
                    })),
                }),
                {
                    cl: 'dot',
                    key: 'dot',
                },
            ],
        };
    }
    updateValue(v) {
        this.setState({
            value: v,
            isEditing: false,
            valueRaw: this.getValueRaw(v),
            selectionPath: this.getSelectionPath(v),
        }, () => {
            this.props.onUpdate?.(Do(() => {
                v = this.state.value;
                if (v != null) {
                    return v.format(this.getValueFormat());
                }
                return null;
            }));
        });
    }
    parseValue(txt) {
        if (!txt) {
            return null;
        }
        const fmt = this.getValueFormat();
        const v = moment(txt, fmt);
        if (v.isValid()) {
            return v;
        }
        console.error(`Could not parse given \`J2rDatetime\` value: '${txt}' with format '${fmt}'`);
        return null;
    }
    getValueFormat() {
        if (this.props.valueFormat != null) {
            return this.props.valueFormat;
        }
        else if (!this.props.includeTime) {
            return 'YYYY-MM-DD';
        }
        else if (!(this.props.includeDate ?? true)) {
            return 'HH:mm';
        }
        return 'YYYY-MM-DD HH:mm:ss';
    }
    onClick() {
        this.setState({
            isOpen: true,
        });
    }
    onTxtFocus() {
        this.setState({
            isFocused: true,
            isOpen: true,
            zoomLevel: this.getDefaultZoom(),
        });
    }
    onTxtBlur() {
        this.setState({
            isFocused: false,
            isOpen: false,
        });
        if (this.state.isEditing) {
            this.attemptToCommitEnteredValue();
        }
    }
    getValueRaw(v) {
        if (v == null) {
            return '';
        }
        else if (this.props.displayFormat != null) {
            return v.format(this.props.displayFormat);
        }
        else if (!this.props.includeTime) {
            return v.format('DD/MM/YYYY');
        }
        else if (!(this.props.includeDate ?? true)) {
            return v.format('HH:mm');
        }
        return v.format('DD/MM/YYYY, HH:mm');
    }
    onTextChanged(e) {
        const val = e.target.value;
        this.setState({
            isEditing: true,
            valueRaw: val,
        });
        if (!val) {
            this.updateValue(null);
            return;
        }
        const fmt = Do(() => {
            if (this.props.displayFormat != null) {
                return this.props.displayFormat;
            }
            else if (!this.props.includeTime) {
                return 'DD/MM/YYYY';
            }
            else if (!(this.props.includeDate ?? true)) {
                return 'HH:mm';
            }
            return 'DD/MM/YYYY, HH:mm';
        });
        const attempted_value = moment(val, fmt, true);
        if (attempted_value.isValid()) {
            this.updateValue(attempted_value);
            return;
        }
    }
    attemptToCommitEnteredValue() {
        const v = this.attemptToParseEnteredValue();
        if (v !== false) {
            this.updateValue(v);
            return;
        }
        this.setState(s => ({
            isEditing: false,
            valueRaw: this.getValueRaw(s.value),
        }));
    }
    attemptToParseEnteredValue() {
        let fmts = [];
        const val = this.state.valueRaw;
        if (!this.props.includeTime) {
            fmts = [
                'DDMMYYYY',
                'YYYYMMDD',
                'DDMMYY',
                'YYMMDD',
                'DD/MM/YYYY',
                'YYYY-MM-DD',
                'D/M/YY',
                'D/M/Y',
                'YY-M-D',
                'Y-M-D',
                'DD.MM.YYYY',
                'YYYY.MM.DD',
                'D.M.YY',
                'D.M.Y',
                'YY.M.D',
                'Y.M.D',
                'DMY',
                'YMD',
            ];
        }
        if (!(this.props.includeDate ?? true)) {
            fmts = [
                'HH:mm',
                'Hmm',
                'H.mm',
                'H:mm',
                'H-mm',
                'H mm',
                'HH:mm:ss',
                'Hmmss',
                'H.mm.ss',
                'H:mm:ss',
                'H-mm-ss',
                'H mm ss',
            ];
        }
        let foundMatch = null;
        for (const fmt of fmts) {
            const v = moment(val, fmt, true);
            if (v.isValid()) {
                foundMatch = v;
                break;
            }
        }
        if (foundMatch != null) {
            const maxYear = this.props.maxYear ?? 2100;
            const minYear = this.props.minYear ?? 1900;
            const year = foundMatch.year();
            if (year > maxYear || year < minYear) {
                return false;
            }
            return foundMatch;
        }
        return false;
    }
    onKeyDown(e) {
        const delta = e.ctrlKey || e.shiftKey ? 7 : 1;
        switch (e.keyCode) {
            case 38:
                this.stopProp(e);
                this.arrowNav(-delta);
                break;
            case 40:
                this.stopProp(e);
                this.arrowNav(delta);
                break;
            case 33:
                this.stopProp(e);
                this.arrowNav(-7 * delta);
                break;
            case 34:
                this.arrowNav(7 * delta);
                break;
            case 13:
                this.attemptToCommitEnteredValue();
                this.setState({ isOpen: false });
                break;
            case 27:
                this.setState(s => ({
                    isOpen: false,
                    isEditing: false,
                    valueRaw: this.getValueRaw(s.value),
                }));
                break;
            default:
                return;
        }
        this.stopProp(e);
    }
    arrowNav(delta) {
        if (!this.props.disableArrowKeys) {
            this.moveNav(delta, this.getDefaultZoom() + 1, () => {
                this.updateValue(this.getValueFromSelectionPath());
            });
        }
    }
    getDefaultZoom() {
        return (this.props.defaultZoom ??
            Do(() => {
                if (this.props.includeDate ?? true) {
                    return 4;
                }
                return 5;
            }));
    }
    getSelectionPath(value = null) {
        value = value ?? this.state?.value ?? moment();
        return [
            Math.floor(value.year() / 10),
            value.year() % 10,
            value.month() + 1,
            value.date(),
            value.hour(),
            Math.round(value.minute() / 12),
        ];
    }
    getValueFromSelectionPath(p = null) {
        p = p ?? this.state.selectionPath;
        if (p == null) {
            return moment();
        }
        return moment({
            year: p[0] * 10 + p[1],
            month: p[2] - 1,
            date: p[3],
            hour: p[4],
            minute: p[5],
            second: 0,
        });
    }
    moveNav(delta, zoomLevel, cb) {
        const deltaFnWrapped = (s) => {
            let zl = zoomLevel;
            if (zl == null) {
                zl = s.zoomLevel;
            }
            zl = clamp(zl, 1, 6);
            const path = _.clone(s.selectionPath);
            const index = zl - 2;
            if (index >= 0 && index < path.length && path[index] != null) {
                path[index] = path[index] + delta;
            }
            else {
                console.warn('Date picker navigation index out of bounds:', {
                    index,
                    zl,
                    pathLength: path.length,
                });
            }
            while (path[5] < 0) {
                path[5] += 60;
                path[4] -= 1;
            }
            while (path[5] > 59) {
                path[5] -= 60;
                path[4] += 1;
            }
            while (path[4] < 0) {
                path[4] += 24;
                path[3] -= 1;
            }
            while (path[4] > 23) {
                path[4] -= 24;
                path[3] += 1;
            }
            while (path[2] < 1) {
                path[2] += 12;
                path[1] -= 1;
            }
            while (path[2] > 12) {
                path[2] -= 12;
                path[1] += 1;
            }
            if (zl >= 4) {
                const d = moment({
                    year: path[0] * 10 + path[1],
                    month: path[2] - 1,
                    date: 1,
                });
                d.add(path[3] - 1, 'd');
                path[0] = Math.floor(d.year() / 10);
                path[1] = d.year() % 10;
                path[2] = d.month() + 1;
                path[3] = d.date();
            }
            while (path[1] < 0) {
                path[1] += 10;
                path[0] -= 1;
            }
            while (path[1] > 9) {
                path[1] -= 10;
                path[0] += 1;
            }
            path[0] = clamp(path[0], 180, 220);
            return { selectionPath: path };
        };
        this.setState(deltaFnWrapped, cb);
    }
    moveNesting(delta) {
        this.setState(s => {
            let zoom = s.zoomLevel + delta;
            zoom = clamp(zoom, 1, 6);
            return { zoomLevel: zoom };
        });
    }
    Focus() {
        const starting_is_open = this.state.isOpen;
        this.element.current?.focus();
        if (!starting_is_open) {
            this.setState({ isOpen: starting_is_open });
        }
    }
    Select() {
        this.element.current?.select();
    }
}
//# sourceMappingURL=component-date-picker.js.map